import * as React from 'react';
import classnames from 'classnames';
import { ProductDetailUspItem } from './ProductDetailUspItem.js';

const ProductDetailUsps = ({ items , layout ='list'  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('product-detail-usps', `product-detail-usps--layout-${layout}`, {
            [`product-detail-usps--columns-3`]: layout === 'grid'
        })
    }, items.map((usp)=>/*#__PURE__*/ React.createElement(ProductDetailUspItem, {
            item: usp,
            key: usp.text
        })
    ));
};

export { ProductDetailUsps };
//# sourceMappingURL=ProductDetailUsps.js.map
